import { Icon } from "@iconify/react";
import { Stack, Typography, useTheme } from "@mui/material";

import { imageSource, Strings } from "@app/constants";

interface NumberItem {
  id: number;
  icon: string;
  numbers: string;
  category: string;
}

interface NumberDataProps {
  data: NumberItem[];
}

const NumberBanner = ({ data }: NumberDataProps) => {
  const theme = useTheme();
  return (
    <Stack
      sx={{
        width: "90%",
        py: 10,
        px: 1,
        alignSelf: "center",
        backgroundImage: `url(${imageSource.lamboUrus})`,
        backgroundSize: "cover",
        position: "relative",
        borderRadius: 2,
        overflow: "hidden",
        backgroundColor: theme.palette.quaternary.darkBlue,
        backgroundBlendMode: "multiply",
        backgroundPosition: "center",
        gap: 3,
      }}
    >
      <Stack>
        <Typography
          sx={{
            textAlign: "center",
            fontSize: 48,
            fontWeight: 700,
            color: theme.palette.common.white,
            lineHeight: 1,
            mb: 1,
          }}
        >
          {Strings.numbersBanner.factsInNumber}
        </Typography>
        <Typography
          variant="body1"
          sx={{
            alignSelf: "center",
            textAlign: "center",
            color: theme.palette.common.white,
            px: 1,
          }}
        >
          {Strings.numbersBanner.ourNumberSpeakFor}
        </Typography>
        <Typography
          variant="body1"
          sx={{
            alignSelf: "center",
            textAlign: "center",
            color: theme.palette.common.white,
            px: 1,
          }}
        >
          {Strings.numbersBanner.fromThousandOfVerified}
        </Typography>
      </Stack>
      <Stack
        sx={{
          mt: 2,
          flexDirection: "row",
          gap: 4,
          alignItems: "center",
          justifyContent: "center",
          flexWrap: "wrap",
        }}
      >
        {data?.map((item) => (
          <Stack
            sx={{
              borderRadius: 2,
              backgroundColor: theme.palette.common.white,
              p: 1.5,
              flexDirection: "row",
              gap: 2,
              width: 180,
            }}
          >
            <Stack
              sx={{
                height: "100%",
                backgroundColor: theme.palette.primary.main,
                p: 1,
                borderRadius: 1,
              }}
            >
              <Icon
                icon={item?.icon}
                color={theme.palette.common.white}
                fontSize={32}
              />
            </Stack>
            <Stack sx={{ flexDirection: "column" }}>
              <Typography variant="body1" fontWeight={700}>
                {item?.numbers}
              </Typography>
              <Typography variant="body2">{item?.category}</Typography>
            </Stack>
          </Stack>
        ))}
      </Stack>
    </Stack>
  );
};

export { NumberBanner };
